/**
 *
 * Asynchronously loads the component for MultiSelectFilter
 *
 */
import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
